import { render, staticRenderFns } from "./ShowConfirm.vue?vue&type=template&id=c9fa3820&"
import script from "./ShowConfirm.vue?vue&type=script&lang=ts&"
export * from "./ShowConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports